<div class="pwa-update-container">
  <!-- Debug button for development only, shown on home and login pages -->
  <div *ngIf="!environment.production && showForceCheckButton" class="mb-2 text-center">
    <p-button label="Force Update Check" icon="pi pi-sync" (onClick)="forceCheck()" severity="warning" styleClass="p-button-sm"></p-button>
  </div>

  <p-toast position="bottom-center" key="update" styleClass="modern-toast">
    <ng-template let-message pTemplate="message">
      <div class="flex align-items-center gap-3 p-3 w-full">
        <div class="flex-1">
          <div class="text-lg font-bold mb-2">{{ message.summary }}</div>
          <div class="text-sm text-color-secondary">{{ message.detail }}</div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <p-button
            label="Update"
            icon="pi pi-refresh"
            (onClick)="updateApp()"
            severity="success"
            styleClass="p-button-sm btn-modern"
          ></p-button>
          <p-button
            label="Later"
            icon="pi pi-times"
            (onClick)="dismissUpdate()"
            severity="secondary"
            styleClass="p-button-sm p-button-outlined btn-modern"
          ></p-button>
        </div>
      </div>
    </ng-template>
  </p-toast>
</div>
